import React from "react";
import { TileV1 as Tile } from "components/tile-v1";

const HeightVariantTileWrapper = ({
  title,
  unit,
  value,
  variant,
  isWholeNumber,
  isFirstColumn,
  origin,
}: any) => {
  return (
    <Tile
      title={title}
      unit={unit}
      value={value}
      variant={variant}
      isClubFittingScreen
      isWholeNumber={isWholeNumber}
      isFirstColumn={isFirstColumn}
      styleVariant={origin}
    ></Tile>
  );
};

export { HeightVariantTileWrapper };
